import React, { useEffect, useState, createRef } from 'react'
import {
  Legend,
  ReportHeading,
  SocialLegend,
  LoaderWrapper,
  ProgressionWrapper,
  ProgressionFilters,
  ReportOuterWrapper,
  NoDataFound2
} from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import * as d3 from 'd3'
import * as fc from 'd3fc'
import { GRAPH_COLOR_PALLET5, LEGEND_COLOR_MAP_NEW } from '../../../../constants'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import InfoRow from './infoRow'
import ReportEditBrandAttributeMap from './reportEditBrandAttributeMap'
import { ROLES_MM_PRIMARY } from '../../../../constants'
import { D3BubbleGraph, D3BubbleGraphNew } from './d3BubbleGraph'
import { getObjectAsArray, sortingDataForProgressionTabList, sortByKey } from '../../../../util'
import { useGlobalStore } from '../../../../store'
import {
  OuterWrapper,
  ContentWrapper,
  ProgressionFiltersWrapper,
  AppendicesHeading,
  LegendWrapper,
  IsAppendicesContentWrapper,
  NoDataAvailable
} from './style'

const ReportBrandAttributeMapElement = (props) => {
  const { InsightsElementType } = props
  const [loading, setLoading] = useState(false)
  const [socialLegend, setSocialLegend] = useState([])
  const [state, setState] = useState([])
  const [colorPallet, setColorPallet] = useState([])
  const [legends, setLegends] = useState([
    { label: 'Relatively Stronger than Category', value: 'Positive' },
    { label: 'At Par with Category', value: 'Mixed' },
    { label: 'Relatively Weaker than Category', value: 'Negative' },
  ])
  const [showGraph, setShowGraph] = useState(false)
  const [pageFlag, setPageFlag] = useState()
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const { isPPTModalActive, user } = useGlobalStore()
  const [eventCount, setEventCount] = useState(1)

  const [progressionDataL1Filtered, setProgressionDataL1Filtered] = useState({
    periods: [],
    drivers: [],
  })
  const [progressionDataSelectedFiltered, setProgressionDataSelectedFiltered] = useState({
    periods: [],
    drivers: [],
  })
  const [configTab, setConfigTab] = useState([])
  const [progressionData, setProgressionData] = useState({})
  const [rows, setRows] = useState([])
  const [tabChanged, setTabChanged] = useState(0)
  const [driverDropdown, setDriverDropdown] = useState([])
  const [graphDetails, setGraphDetails] = useState({
    AxisCutHorizontal: 0,
    AxisCutVertical: 0,
    AxisNameHorizontal: '',
    AxisNameVertical: '',
    range: { x: [0, 10], y: [1, 10] },
  })
  const [domainValues, setDomainValues] = useState({})
  const [graphData, setGraphData] = useState()
  const [graphDataArray, setGraphDataArray] = useState()
  const [reportExcelData, setReportExcelData] = useState()
  const [noDataInFilters, setNoDataInFilters] = useState(true)

  const isTriangulation = ['TriangulationMapAndProgression', 'TriangulationMapElement'].includes(
    InsightsElementType
  )
  const isTriangulationProgression = ['TriangulationMapAndProgression'].includes(
    InsightsElementType
  )
  const isBrandAttributeMap = [
    'BrandAttributeMapElement',
    'BrandAttributeMapAndProgression',
  ].includes(props.InsightsElementType)
  let scalingVal = isTriangulation ? 0 : 1.5

  let scoreImageryTypeArray = {}
  let scoreImageryTypeArrayL2 = {}
  const filterDataObj = { drivers: [], periods: [] }
  const progressionFiltersSettings = {
    driverRadio: true,
  }

  const hasTabs = ['BrandAttributeMapAndProgression', 'TriangulationMapAndProgression'].includes(
    InsightsElementType
  )

  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc: hasTabs
        ? ReportsService.reportGetBrandAttributeMapProgressionElementApi
        : ReportsService.reportGetBrandAttributeMapElementApi,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const { data, isLoading, isSuccess, isError, error, refetch } = useReactQuery(useReactQueryObject)

  const getColorForSentiments = (sentiment, shade = 'light') => {
    if (shade === 'light') {
      if (isTriangulation) {
        return legends.find((f) => f.value === sentiment).colorLight
      } else {
        return sentiment === 'Positive'
          ? 'rgba(0, 176, 80, 0.4)'
          : sentiment === 'Negative'
            ? 'rgba(255, 0, 0, 0.4)'
            : 'rgba(166, 166, 166, 0.4)'
      }
    } else if (shade === 'dark') {
      if (isTriangulation) {
        return legends.find((f) => f.value === sentiment).colorDark
      } else {
        return sentiment === 'Positive'
          ? 'rgba(0, 176, 80, 1)'
          : sentiment === 'Negative'
            ? 'rgba(255, 0, 0, 1)'
            : 'rgba(166, 166, 166, 1)'
      }
    }
  }

  const rangeFunc = (resp) => {
    const xValues = resp.map((d) => d.BuzzVolumeIndex)
    const yValues = resp.map((d) => d.MeanRatingIndex)
    const xMin = Math.min(...xValues) - 2.5
    const xMax = Math.max(...xValues) * 2
    const yMin = Math.min(...yValues) - 2.5
    const yMax = Math.max(...yValues) * 2
    return { x: [xMin, xMax], y: [yMin, yMax] }
  }

  const excelFunc = (resp) => {
    const reportExcelDataObj = {
      values: [],
    }

    for (let i = 0; i < resp.length; i++) {
      const sentimentValue = legends.filter((f) => f.value === resp[i].Sentiment)?.[0]?.label
      reportExcelDataObj.values.push([
        { value: resp[i].DriverName },
        { value: resp[i].PercentEngagement },
        { value: sentimentValue || resp[i].Sentiment },
      ])
    }
    setReportExcelData(reportExcelDataObj.values)
  }

  const loadAxisDataFunc = async (resp, hasTabs) => {
    setPageFlag(true)
    setLoading(true)

    const payload = hasTabs
      ? { insightsElementId: resp[0].PeriodInsightsElementId }
      : { insightsElementId: props.InsightsElementId }
    await ReportsService.reportGetTriangulationGraphConfigurationApi(payload)
      .then((response) => {
        if (response.length > 0) {
          const rangeData = hasTabs
            ? getObjectAsArray(resp)[0].PeriodBrandAttributeMapElements.BrandAttributeMapElement
            : getObjectAsArray(resp)
          const details = { ...response?.[0], range: rangeFunc(rangeData) }
          // const detailsNew = {...response?.[0], range:getMinMaxScalingFunc(rangeData, 'return')}
          setGraphDetails(details)
          generateProgressionGraphData(resp, hasTabs, details)
          // excelFunc(rangeData)
        }
      })
      .catch((error) => {
        const resMessage = error
        console.log('ERROR : ', resMessage)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const generateProgressionGraphData = async (resp, hasTabs, details) => {
    scoreImageryTypeArray = {}
    scoreImageryTypeArrayL2 = {}

    // GetAllSentiments
    const getAllSentiments = () => {
      if (isTriangulation) {
        const legendsArray1 = hasTabs
          ? getObjectAsArray(resp)
              .map((d) => d.PeriodBrandAttributeMapElements.BrandAttributeMapElement)
              .flat(1)
          : getObjectAsArray(resp)
        const legendsOrder2 = (str) => {
          return legendsArray1.find((f) => f.Sentiment === str)?.DriverOrder
        }
        const legendsArray2 = [...new Set(legendsArray1.map((d) => d.Sentiment))]
          .map((str, i) => ({ label: str, value: str, order: legendsOrder2(str) }))
          .sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0))
          .map((d, i) => ({
            ...d,
            colorLight: GRAPH_COLOR_PALLET5[i] + 'bf',
            colorDark: GRAPH_COLOR_PALLET5[i],
          }))
        setLegends(legendsArray2)
        setColorPallet(legendsArray2.map((f) => f.colorDark))
      }
    }
    getAllSentiments()

    const rowArrayDataFunc = (data, dataObj) => {
      filterDataObj.periods.push(dataObj?.title || '')
      filterDataObj.drivers.push(data.map((d) => d.DriverName))

      const finalData = data.map((d) => {
        return {
          ...d,
          title: d.DriverName,
          graphs: [
            {
              value: d?.BrandMagnetScore,
              barData: [{ Warning: d?.BrandMagnetScore }],
            },
          ],
        }
      })

      return finalData
    }

    const configTabObject = hasTabs
      ? resp.map((d, i) => {
          return {
            periodInsightsElementId: d.PeriodInsightsElementId,
            id: i,
            label: i === 0 ? d.PeriodName : 'Progression',
            tutorial: i === 0 ? 'CurrentPeriod' : 'Progression',
            title: d.PeriodName,
            periodOrder: d.PeriodOrder,
            data: getObjectAsArray(d.PeriodBrandAttributeMapElements.BrandAttributeMapElement),
          }
        })
      : []

    const rowArrayData = hasTabs
      ? configTabObject.map((d) => {
          d.data = rowArrayDataFunc(d.data, d)
          return d
        })
      : [rowArrayDataFunc(resp, null)]

    const rowArray = hasTabs
      ? rowArrayData[0].data.map((d) => ({
          ...d,
          PeriodInsightsElementId: rowArrayData[0].periodInsightsElementId,
        }))
      : rowArrayData[0]

    const removeUsingSet = (arr) => {
      let outputArray = Array.from(new Set(arr))
      return sortingDataForProgressionTabList(outputArray)
    }

    const progressionDataL1FilteredData = {
      drivers: removeUsingSet(filterDataObj.drivers.flat(1)),
      periods: removeUsingSet(filterDataObj.periods),
    }
    setProgressionDataL1Filtered(progressionDataL1FilteredData)

    if (hasTabs) {
      setConfigTab(configTabObject)

      const progressionObj = {}

      for (let i = 0; i < configTabObject.length; i++) {
        const d1 = configTabObject[i].data
        for (let j = 0; j < d1.length; j++) {
          if (!progressionObj[d1[j]?.DriverName]) {
            progressionObj[d1[j].DriverName] = []
          }

          progressionObj[d1[j].DriverName].push({
            PeriodName: configTabObject[i].title,
            BuzzVolumeIndex: d1[j].BuzzVolumeIndex,
            DriverId: d1[j].DriverId,
            DriverName: configTabObject[i].title,
            // DriverName: d1[j].DriverName,
            InsightsElementId: d1[j].InsightsElementId,
            PeriodInsightsElementId: configTabObject[i]?.periodInsightsElementId || null,
            MeanRatingIndex: d1[j].MeanRatingIndex,
            PercentEngagement: d1[j].PercentEngagement,
            Sentiment: d1[j].Sentiment,
          })
        }
      }

      setProgressionData(progressionObj)
    }

    const driverDropdownArray = rowArray.map((d) => ({
      value: d.DriverId,
      label: d.DriverName,
      DriverId: d.DriverId,
      DriverName: d.DriverName,
      InsightsElementId: d.InsightsElementId,
      PeriodInsightsElementId: d?.PeriodInsightsElementId || null,
    }))
    setDriverDropdown(driverDropdownArray)

    setState(rowArray)
    setRows(rowArray)
    updateSubLhsApiLoaded(props)
    setEventCount((p) => p + 1)
  }

  const filterChangeFunc = (data) => {
    setProgressionDataSelectedFiltered(data)
    if (data?.drivers?.length > 0) {
      setGraphData([])
      setTimeout(() => {
        setGraphData((prev) =>
          progressionData[data.drivers[0]].filter((f) => data.periods.includes(f.PeriodName))
        )
      }, 0)
    }
  }

  useEffect(() => {
    if (!loading && state.length) {
      // if(tabChanged === 0 ) { drawScatter(state, props, false) }
      setGraphData([])
      if (tabChanged === 0) {
        setTimeout(() => {
          setGraphData((prev) => state)
        })
        // testGraph(state, props, false)
      }
      if (tabChanged === 1) {
        // setGraphData([]);
        // const driverKey = Object.keys(progressionData)[0]
        // setProgressionDataSelectedFiltered({...progressionDataSelectedFiltered, drivers:[]})
        // drawScatter(progressionData[driverKey], props, true)
      }
      setEventCount((p) => p + 1)
    }
    setTimeout(() => {
      setProgressionDataSelectedFiltered({...progressionDataSelectedFiltered, drivers:[]})
    }, 50)
  }, [tabChanged])

  useEffect(() => {
    if (!loading && state.length && !props?.isProgressionActive) {
      // drawScatter(state, props)
      // testGraph(state, props)
      setGraphData(state)
      setEventCount((p) => p + 1)
    }
  }, [loading, state])

  useEffect(() => {
    if (
      props?.isProgressionActive &&
      ['BrandAttributeMapAndProgression', 'TriangulationMapAndProgression'].includes(
        props.InsightsElementType
      ) &&
      progressionDataL1Filtered.drivers.length > 0 &&
      progressionDataL1Filtered.periods.length > 0
    ) {
      const key = Object.keys(progressionData)
      const graphDataArr = []
      for (let i = 0; i < key.length; i++) {
        // testGraph( progressionData[key[i]], props, false, i )
        // setGraphData(progressionData[key[i]])
        graphDataArr.push(progressionData[key[i]])
      }
      setGraphDataArray(graphDataArr)
      setGraphData([])
    }
  }, [props, progressionDataSelectedFiltered])

  const onInsightsChange = (p) => {
    document.getElementById(`Svg_${props.type}_Wrapper`).removeAttribute('style')
    document.getElementById(`Svg_${props.type}`).innerHTML = '<b>deleted</b>'
    // testGraph(state, props)
    setGraphData(state)
  }

  const EditButton = () => {
    return (
      <>
        {ROLES_MM_PRIMARY.includes(user?.UserType) && driverDropdown.length > 0 && (
          <ReportEditBrandAttributeMap
            InsightsElementId={props.InsightsElementId}
            dropdownData={driverDropdown}
            pageData={state}
            onSuccess={(e) => {
              refetch()
            }}
          />
        )}
      </>
    )
  }

  const getMinMaxScalingFunc = (resp, type = '') => {
    const data = hasTabs
      ? getObjectAsArray(resp)
          .map((d) => d.PeriodBrandAttributeMapElements.BrandAttributeMapElement)
          .flat(1)
      : getObjectAsArray(resp)
    const rangeData = hasTabs
      ? getObjectAsArray(resp)[0].PeriodBrandAttributeMapElements.BrandAttributeMapElement
      : getObjectAsArray(resp)
    const padding = isBrandAttributeMap ? 0 : 5
    const domainValueObj = {
      xMin: d3.min(data, (d) => parseInt(d.BuzzVolumeIndex - scalingVal)) - padding,
      xMax: d3.max(data, (d) => parseInt(d.BuzzVolumeIndex + scalingVal)) + padding,
      yMin: d3.min(data, (d) => parseInt(d.MeanRatingIndex - scalingVal)) - padding,
      yMax: d3.max(data, (d) => parseInt(d.MeanRatingIndex + scalingVal)) + padding,
    }
    if (type === 'return') {
      return {
        x: [domainValues.xMin, domainValues.xMax],
        y: [domainValues.yMin, domainValues.yMax],
      }
    }
    setDomainValues(domainValueObj)
    excelFunc(rangeData)
  }

  const onSuccessFunc = (resp) => {
    getMinMaxScalingFunc(resp)

    if (isTriangulation) {
      loadAxisDataFunc(resp, hasTabs)
    } else {
      const details = {
        ...graphDetails,
        AxisCutHorizontal: 0,
        AxisCutVertical: 1,
        AxisNameHorizontal: 'Buzz Index (Relative Importance of the Insight Space vs. Category)',
        AxisNameVertical: 'Sentiment (Positivity of the Insight Space vs. Category)',
        range: rangeFunc(resp),
        // range:getMinMaxScalingFunc(resp, 'return')
      }
      setGraphDetails(details)
      generateProgressionGraphData(resp, hasTabs, details)
    }
  }

  useEffect(() => {
    if (isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data])

  useEffect(() => {
    setTimeout(() => {
      setShowGraph(true)
    }, 2000)
  }, [])

  useEffect(() => {
    if(progressionDataSelectedFiltered.drivers?.length === 0 || progressionDataSelectedFiltered.periods?.length === 0){
      setNoDataInFilters(true)
    } else {
      setNoDataInFilters(false)
    }
  }, [progressionDataSelectedFiltered.drivers, progressionDataSelectedFiltered.periods])

  return (
    <>
      {reportExcelData?.length && (
        <ReportHeading
          resetInsightHeight={eventCount}
          downloadId={props.type}
          downloadIdData={reportExcelData}
          {...props}
          onInsightsChange={(p) => onInsightsChange(p)}
          additionalButton={<EditButton />}
        />
      )}
      <ReportOuterWrapper>
        <OuterWrapper id={props.type} className={props?.isPPTModalActive ? 'isPPTModalActive' : ''}>
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            {!props?.isProgressionActive && (
              <ProgressionWrapper configTab={configTab} onChange={setTabChanged}>
                <ContentWrapper className='brandAttributeMapRow'>
                  {tabChanged === 0 && ['BrandAttributeMapElement', 'BrandAttributeMapAndProgression'].includes(props.InsightsElementType) && graphData?.length > 0 && showGraph && (
                    <D3BubbleGraph
                      id={`Svg_${props.type}_____`}
                      isTriangulation={isTriangulation}
                      data={graphData}
                      graphDetails={graphDetails}
                      tabChanged={tabChanged}
                      domainValues={domainValues}
                      legends={legends}
                      socialLegend={socialLegend}
                      {...props}
                    />
                  )}
                  {tabChanged === 0 && !['BrandAttributeMapElement', 'BrandAttributeMapAndProgression'].includes(props.InsightsElementType) && graphData?.length > 0 && showGraph && (
                    <D3BubbleGraphNew
                      id={`Svg_${props.type}_____`}
                      isTriangulation={isTriangulation}
                      data={graphData}
                      graphDetails={graphDetails}
                      tabChanged={tabChanged}
                      domainValues={domainValues}
                      legends={legends}
                      socialLegend={socialLegend}
                      {...props}
                    />
                  )}

                  {!isTriangulation && <InfoRow />}
                  <LegendWrapper>
                    <Legend legends={legends} colorPallet={colorPallet} />
                    <SocialLegend legends={socialLegend} />
                  </LegendWrapper>
                </ContentWrapper>
                <ContentWrapper style={{ minHeight: '550px' }}>
                  {progressionDataL1Filtered?.drivers?.length > 0 && (
                    <ProgressionFiltersWrapper>
                      <ProgressionFilters
                        settings={progressionFiltersSettings}
                        data={progressionDataL1Filtered}
                        onChange={filterChangeFunc}
                      />
                    </ProgressionFiltersWrapper>
                  )}

                  {/* Development WIP 1 */}
                  {tabChanged === 1 && showGraph && noDataInFilters && (<NoDataFound2 size='large' description='Please select an attribute to see the progression' />)}
                  {tabChanged === 1 && showGraph && (
                    <D3BubbleGraphNew
                      noDataInFilters={noDataInFilters}
                      id={`Svg_${props.type}___progression_`}
                      isTriangulation={isTriangulation}
                      data={graphData}
                      graphDetails={graphDetails}
                      tabChanged={tabChanged}
                      domainValues={domainValues}
                      legends={legends}
                      socialLegend={socialLegend}
                      {...props}
                    />
                  )}

                  {!isTriangulation && <InfoRow />}
                  <LegendWrapper>
                    <Legend legends={legends} colorPallet={colorPallet} />
                    <SocialLegend legends={socialLegend} />
                  </LegendWrapper>
                </ContentWrapper>
              </ProgressionWrapper>
            )}

            {props?.isProgressionActive &&
              ['BrandAttributeMapAndProgression', 'TriangulationMapAndProgression'].includes(
                props.InsightsElementType
              ) && (
                <IsAppendicesContentWrapper>
                  {graphDataArray?.length > 0 &&
                    progressionDataL1Filtered.drivers.length > 0 &&
                    progressionDataL1Filtered.periods.length > 0 &&
                    progressionDataL1Filtered.drivers.map((p, i) => {
                      return (
                        <>
                          <ContentWrapper className='brandAttributeMapRowProgression'>
                            <AppendicesHeading className='brandAttributeMapLevel2'>
                              {p}
                            </AppendicesHeading>

                            {graphDataArray?.length > 0 && showGraph && (
                              <D3BubbleGraphNew
                                id={`Svg_${props.type}___${i}__progression`}
                                appendicesIndex={i}
                                // titleOrderedArrayFunc={titleOrderedArrayFunc}
                                isTriangulation={isTriangulation}
                                data={graphDataArray[i]}
                                graphDetails={graphDetails}
                                tabChanged={tabChanged}
                                domainValues={domainValues}
                                legends={legends}
                                socialLegend={socialLegend}
                                {...props}
                              />
                            )}

                            {!isTriangulation && <InfoRow />}
                            <LegendWrapper>
                              <Legend legends={legends} colorPallet={colorPallet} />
                              <SocialLegend legends={socialLegend} />
                            </LegendWrapper>
                          </ContentWrapper>
                        </>
                      )
                    })}
                </IsAppendicesContentWrapper>
              )}
          </LoaderWrapper>
        </OuterWrapper>
      </ReportOuterWrapper>
    </>
  )
}

export default ReportBrandAttributeMapElement
